import { useState } from "react";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";

import GenericListContainer from "../GenericList/GenericListContainer";
import { GET_LOGIN_DATA, GET_PROJECT } from "../GraphQl/query";
import { duplicateResponse } from "../Helpers/functions";
import { PRJVERSION, PRJUNITS } from "../../navigation/Routes";
import { PageWrapper } from "../PageWrapper";
import BudgetModal from "../Modals/Budgets/BudgetModal";

const ProjectMangerContainer = () => {
  const [budgetState, toggleBudgetState] = useState(false);
  const { data: auth } = useQuery(GET_LOGIN_DATA);
  const userId = auth?.userInfo?.id || "";

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, loading, error } = useQuery(GET_PROJECT, {
    skip: !userId,
    variables: { managerId: userId },
  });

  const projectList = duplicateResponse(data?.result);
  const additionalColumns = [
    {
      accessor: "Budget",
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Button
          color="info"
          onClick={() => {
            toggleBudgetState(row.original.id);
          }}
        >
          {t("budgetButton")}
        </Button>
      ),
    },
    {
      accessor: "details",
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Button
          color={"info"}
          onClick={() =>
            navigate(`${PRJVERSION}/${row.original.id}`, {
              state: {
                projectCode: row.original.code,
                missingheader:
                  row.original.code + "\n" + row.original.instituteDescription,
              },
            })
          }
        >
          {t("projectVersion")}
        </Button>
      ),
    },
    {
      accessor: "unit",
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Button
          color="info"
          onClick={() => navigate(`${PRJUNITS}/${row.original.id}`)}
        >
          {t("unityButton")}
        </Button>
      ),
    },
  ];

  return (
    <PageWrapper loading={loading} error={error}>
      <GenericListContainer
        list={projectList}
        additionalColumns={additionalColumns}
        structureName={"Project"}
        parentValue={"managerPage"}
      />
      {budgetState && (
        <BudgetModal
          toggleBudgetState={toggleBudgetState}
          projectId={budgetState}
        />
      )}
    </PageWrapper>
  );
};

export default ProjectMangerContainer;
